<script context="module">
	import { z } from "zod";
	export const name = "large opening box";

	export const CustomFields = z.object({
		backgroundColor: z.string().nullable(),
	});
</script>

<script lang="ts">
	import { getContext } from "svelte";
	import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
	import { stripTags } from "@reperio-news/core.components/includes/Helpers";
	type Data = z.infer<typeof Data>;
	import ImageView from "@reperio-news/core.components/ImageView.svelte";

	const context: SvelteStore<any> = getContext("context");

	export let data: Data = {};
</script>

{#if data && data.content}
	<div
		class="entry"
		style="--bgColor: {data.custom_fields?.backgroundColor ||
			$context.domain_config.MISC.boxColor};"
	>
		<a class="info" href={data.content.url} title={data.content.summary}>
			<span class="title">{@html stripTags(data.content.title, ["i", "b", "strong", "font"])}</span>
			<span class="summary">{@html stripTags(data.content.summary, ["i", "b", "strong", "font"])}</span>
		</a>

		{#if data.content.poster}
			<a
				class="image"
				href={data.content.url}
				title={data.content.summary}
			>
				<!-- the box is a fluid-width, fixed-400px-tall column (ratio
				     ~1.25-1.95 across breakpoints): request the middle (3:2)
				     so the residual CSS crop stays small; srcset ratios kept
				     consistent (500/400 vs 400/300 used to differ) -->
				<ImageView
					src={data.content.poster}
					crop={data.content.poster.crop}
					width={600}
					height={400}
					widths={[600, 450]}
					heights={[400, 300]}
					animatedQuality={45}
					fit="cover"
				/>
			</a>
		{/if}
	</div>
{/if}

<style lang="scss">
	.entry {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		height: 400px;
		overflow: hidden;

		a.info {
			padding: 30px;
			width: calc(50% - 60px);
			height: 350px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			text-decoration: none;
			color: inherit;
			background-color: var(--bgColor);

			.title {
				font-size: 30px;
				font-weight: 900;
				color: #fff;
				margin-bottom: 20px;
				text-shadow: -1px -1px 1px rgba(255, 255, 255, 0.1),
					1px 1px 1px rgba(0, 0, 0, 0.5);
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				text-overflow: hidden;
				white-space: normal;
				text-overflow: ellipsis;
				-webkit-line-clamp: 4;
			}

			.summary {
				color: #fff;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				text-overflow: hidden;
				white-space: normal;
				text-overflow: ellipsis;
				-webkit-line-clamp: 4;
			}
		}

		a.image {
			width: 50%;
			height: 400px;
		}
	}

	@media screen and (max-width: 800px) {
		.entry {
			flex-direction: column-reverse;
			height: auto;
		}

		.entry a.info {
			width: calc(100% - 60px);
			height: auto;
		}

		.entry a.image {
			width: 100%;
			height: 400px;
		}
	}

	@media screen and (max-width: 500px) {
		.entry {
			a.image {
				height: 300px;
			}

			.info {
				.title {
					font-size: 22px !important;
				}

				.summary {
					display: none !important;
				}
			}
		}
	}
</style>
